import React from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
import { PricingSection } from './PricingSection';
import { Lock, Zap, Shield } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-149">
      <div className="absolute inset-0 bg-gradient-to-b from-navy-900 via-navy-800 to-navy-900 z-0" data-id="element-150"></div>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-full bg-gold-500/5 blur-[120px] rounded-full z-0 pointer-events-none" data-id="element-151"></div>

      <div className="relative z-10 max-w-6xl mx-auto" data-id="element-152">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12 max-w-3xl mx-auto" data-id="element-153">
          <p className="text-gold-400 font-bold tracking-wider uppercase text-sm mb-4" data-id="element-154">
            🐾 MUNDORECURSOS™
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight" data-id="element-155">
            El próximo lunes podés volver a salir con el estómago apretado.
          </h2>
          <p className="text-xl text-blue-100 mb-6" data-id="element-156">
            O podés entrar y salir de tu departamento sabiendo que tu perro está
            tranquilo, que el vecino no va a llamar y que la puerta va a seguir
            entera.
          </p>
          <p className="text-2xl font-bold text-gold-400" data-id="element-157">
            ¿Cuánto más tiempo vas a esperar?
          </p>
        </motion.div>

        <CountdownTimer data-id="element-158" />

        <PricingSection data-id="element-159" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-16 flex flex-wrap justify-center gap-6 md:gap-12 text-sm md:text-base font-medium text-blue-200/80" data-id="element-160">
          <div className="flex items-center gap-2" data-id="element-161">
            <Lock className="w-5 h-5 text-gold-400/70" data-id="element-162" /> Pago 100% seguro
          </div>
          <div className="flex items-center gap-2" data-id="element-163">
            <Zap className="w-5 h-5 text-gold-400/70" data-id="element-164" /> Acceso en 5 minutos
          </div>
          <div className="flex items-center gap-2" data-id="element-165">
            <Shield className="w-5 h-5 text-gold-400/70" data-id="element-166" /> Garantía 7 días
          </div>
        </motion.div>
      </div>
    </section>;
}